import { __exports as a } from "../../../_virtual/index2.js";
import h from "../../../_virtual/index3.js";
import { __require as P } from "../../leaflet/dist/leaflet-src.js";
import { __require as q } from "../../leaflet.markercluster/dist/leaflet.markercluster-src.js";
import './assets/MarkerCluster.Default.css';import './assets/MarkerCluster.css';/* empty css                         */
/* empty css                                 */
import j from "../../../_virtual/marker-icon-2x.png.js";
import E from "../../../_virtual/marker-icon.png.js";
import C from "../../../_virtual/marker-shadow.png.js";
var v;
function S() {
  if (v) return a;
  v = 1;
  var l = a && a.__assign || function() {
    return l = Object.assign || function(r) {
      for (var n, t = 1, e = arguments.length; t < e; t++) {
        n = arguments[t];
        for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (r[o] = n[o]);
      }
      return r;
    }, l.apply(this, arguments);
  }, _ = a && a.__rest || function(r, n) {
    var t = {};
    for (var e in r) Object.prototype.hasOwnProperty.call(r, e) && n.indexOf(e) < 0 && (t[e] = r[e]);
    if (r != null && typeof Object.getOwnPropertySymbols == "function")
      for (var o = 0, e = Object.getOwnPropertySymbols(r); o < e.length; o++)
        n.indexOf(e[o]) < 0 && Object.prototype.propertyIsEnumerable.call(r, e[o]) && (t[e[o]] = r[e[o]]);
    return t;
  }, m = a && a.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(a, "__esModule", { value: !0 });
  var f = h, p = m(P());
  q(), delete p.default.Icon.Default.prototype._getIconUrl, p.default.Icon.Default.mergeOptions({
    iconRetinaUrl: j.default,
    iconUrl: E.default,
    shadowUrl: C.default
  });
  function b(r) {
    var n = {}, t = {};
    r.children;
    var e = _(
      r,
      ["children"]
    );
    return Object.entries(e).forEach(function(o) {
      var u, c, i = o[0], s = o[1];
      i.startsWith("on") ? t = l(l({}, t), (u = {}, u[i] = s, u)) : n = l(l({}, n), (c = {}, c[i] = s, c));
    }), { clusterProps: n, clusterEvents: t };
  }
  function d(r, n) {
    var t = b(r), e = t.clusterProps, o = t.clusterEvents, u = new p.default.MarkerClusterGroup(e);
    return Object.entries(o).forEach(function(c) {
      var i = c[0], s = c[1], g = "cluster".concat(i.substring(2).toLowerCase());
      u.on(g, s);
    }), (0, f.createElementObject)(u, (0, f.extendContext)(n, { layerContainer: u }));
  }
  var O = function(r, n, t) {
  }, y = (0, f.createPathComponent)(d, O);
  return a.default = y, a;
}
export {
  S as __require
};
